import { Component, OnInit } from '@angular/core';
import { LogoComponent } from "../../../../shared/components/logo/logo.component";
import { PrimaryButtonComponent } from "../../../../shared/components/primary-button/primary-button.component";
import { TermsAndConditionsComponent } from "../../components/terms-and-conditions/terms-and-conditions.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TrimEmailPipe } from '../../../../core/pipes/trim-email.pipe';

@Component({
  selector: 'app-check-email',
  standalone: true,
  imports: [LogoComponent, PrimaryButtonComponent, TermsAndConditionsComponent, TranslocoPipe, TrimEmailPipe, RouterLink],
  templateUrl: './check-email.component.html',
  styleUrl: './check-email.component.css'
})
export class CheckEmailComponent implements OnInit {
  userEmail: string = "";
  promotionCode: string | undefined = undefined;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.userEmail = params['email'];
      this.promotionCode = params['promotion']
    });
  }

  // Redirecting user to sign up page
  signUpPage() {
    this.router.navigate(["/auth/temp-password"], { queryParams: { email: this.userEmail, promotion: this.promotionCode } });
  }
}
